export default __webpack_public_path__ + "static/media/img-test-intro.8804e7fd.jpg";